
import { createHashHistory } from 'history'

import Swal from 'sweetalert2/dist/sweetalert2.js'
import timemachine from 'timemachine';

import { HubConnectionBuilder } from "@aspnet/signalr";

import { saveOfflineData, checkIsOffline, getOfflineData } from "./reactNativeListener";

// import moment from 'moment';

const param = require('jquery-param');

const OriginalDate = timemachine.OriginalDate;
// const OriginalDate = Date;

console.log("window.location", window.location);
console.log("window.location 1", window.host);
window.host = `https://${window.location.hostname}:7010`;
// window.host = `http://${window.location.hostname}:3532`; 


console.log("window.location 2", window.host);

window.isTablet = (function () {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  // alert(navigator.userAgent);
  if (!check && navigator.userAgent.match(/iPad|iPhone|Android/i)) return true;
  console.log("check", check);
  return check;
})();
window.isiPhone = (function () {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  //if (navigator.userAgent.match(/iPhone/i)) return true;

  return check;
})();

window.isReactNative = window.ReactNativeWebView ? true : false;
window.isTablet = window.isTablet || window.isReactNative;

// console.log({ Tablet: window.isTablet, iphone: window.isiPhone, ReactNative: window.isReactNative });
// alert(JSON.stringify({ Tablet: window.isTablet, iphone: window.isiPhone, ReactNative: window.isReactNative }));

const KeyReserve = ['language', 'host'];
class LoginInfo {

  constructor() {

    this.reset();
  }

  reset() {
    Object.keys(this).forEach(key => {
      if (typeof this[key] === 'function' || KeyReserve.includes(key)) return;
      delete this[key];
    });

    this.IsTablet = window.isTablet;
    this.IsMobile = window.isiPhone;
    this.IsReactNative = window.isReactNative;
    this.ResponseTimestamp = new OriginalDate();
    this.lastState = {};
  }

  save() {
    sessionStorage["loginInfo"] = JSON.stringify(this);
    localStorage["loginInfo"] = JSON.stringify(this);
    setCookie("sessionID", this.Session, 1);
    setCookie("UserID", this.UserID, 1);
  }

  clear() {
    sessionStorage.clear();
    this.reset();
    console.log("After Logout", this);
  }

  startUpdateSession() {
    this.endUpdateSession();
    this.updateSession();
  }

  updateSession(atonce) {
    let isOffline = checkIsOffline();
    if (!this.Session || isOffline) return;

    if (!atonce) {

      var diff = timeDiffInSeconds(new OriginalDate(), this.ResponseTimestamp);
      if (diff < 25) {

        setTimeout(() => {
          this.updateSession();
        }, 25000 - diff * 1000);

        return;
      }
    }

    var url = 'UpdateSession';

    ajaxPost(url, {}).then(response => {
      console.log(response);


      setTimeout(() => {
        this.updateSession();
      }, 25000);
    });

  }

  endUpdateSession() {
    if (this.intervalID) {

      clearInterval(this.intervalID);
      delete this.intervalID;
    }
  }
}

export const history = createHashHistory({
  basename: '',             // The base URL of the app (see below)
  hashType: 'slash',        // The hash type to use (see below)
  getUserConfirmation(message, callback) {
    window.lastURL = history.location.pathname;

    callback(true);
  }
})

// export const history = createBrowserHistory();

// export const history = useRouterHistory(createBrowserHistory)({
//   basename: '/basename'
// });

window.ajaxCount = 0;
export const ajaxPost = function (url, data, synchronized) {

  // console.log("ajaxPost entry");
  if (synchronized && window.ajaxCount > 0) return Promise.resolve(null);

  // console.log("ajaxPost in");

  if (loginInfo.Session) {
    data.session = loginInfo.Session;
    data.Ledger = loginInfo.Ledger;
  }
  var logObj = {
    url: url,
    data: data,
  }
  if (synchronized)
    window.ajaxCount++;


  // window.isOffLine
  // if (data.offlineKey) {
  //   let dataKey = `${data.offlineUrl || url}-${data.offlineKey}`;
  //   let isOffline = checkIsOffline();
  //   if (isOffline) {
  //     let offlineData = getOfflineData(dataKey);
  //     return Promise.resolve(offlineData);
  //   }
  // }

  //if(checkIsOffline()){
  // let offlineData = getOfflineData(dataKey);
  //return Promise.resolve({});
  //}

  return fetch(`${window.host}/${url}`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(data),
    // body: param(data),
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  }).then(response => {

    loginInfo.ResponseTimestamp = new OriginalDate();

    if (synchronized)
      window.ajaxCount--;

    if (response.status != 200) {
      delete loginInfo.UserID;
      history.replace('/login');
      return false;
    }
    return response.json();
  }).then(function (response) {
    // console.log("errorMessage");
    console.log(`${url} response: `, response);
    if (response && response.errorMessage) {
      alert(response.errorMessage, undefined, 'error');
      logObj.response = response.errorMessage

      // if (logMessageToChatRoom)
      //   logMessageToChatRoom('ajaxPost response ' + JSON.stringify(logObj))
      // return false;
      // controller.abort();
    }

    if (response && response.SystemDate) {
      // response.SystemDate = "2020-04-27T17:57:52.8002513+08:00";
      let systemTimestamp = OriginalDate.parse(response.SystemDate);
      timemachine.config({
        timestamp: systemTimestamp,
        tick: true,
      });
      if (typeof (sessionStorage) !== "undefined") {
        sessionStorage["SystemTimestamp"] = systemTimestamp;
        sessionStorage["OriginTimestamp"] = new OriginalDate().getTime();

      }
    }

    return response;

  }).catch(function (response) {

    // if (!skipCountCheck)
    //   window.ajaxCount--;

    if (response.message) {
      alert(`${url}: ${response.message}`, undefined, 'error');
      // console.log(`${url}: ${response.message}`, undefined, 'error');
      // history.push("/login");
    }

  });
}

export const ajaxGet = function (url, data) {
  return fetch(`${window.host}/${url}`, {
    method: 'GET',
    credentials: 'include',
    body: param(data),
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  }).then(response => {
    if (response.status != 200) {
      delete loginInfo.UserID;
      history.replace('/login');
      return false;

    }
    return response.json()

  });
}

export const setCookie = function (cname, cvalue, exdays) {
  var d = new OriginalDate();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const updateLanguage = function (callback) {

  let url = 'FB.UpdateLanguage';
  let data = { Language: loginInfo.language };

  ajaxPost(url, data).then(response => {

    console.log(response);
    if (callback)
      callback();

  });
}

export const setLanguage = function (language, notUpdateServer, path) {
  console.log("setLanguage: ", language)
  setCookie("language", language || 'eng', 30);
  loginInfo.language = language || 'eng';
  window.LabelMapping = window.LabelMappingDict[loginInfo.language];
  if (notUpdateServer)
    history.goBack();
    // history.replace('/');
  else
    updateLanguage(() => {
      if (path)
        history.push(path)
      location.reload();
    })

}

export const checkLanguage = function () {
  var language = getCookie("language");
  loginInfo.language = language || 'eng';

  window.LabelMapping = window.LabelMappingDict[loginInfo.language];
}

export const setUserPreference = function (userPreference) {
  setCookie("UserPreference", JSON.stringify(userPreference || {}), 30);
  loginInfo.UserPreference = userPreference || {};
  console.log("setUserPreference: ", loginInfo.UserPreference)
  console.log("compare", userPreference, "\n", loginInfo.UserPreference, "\n", loginInfo)

  if (loginInfo.language != userPreference.Language)
    setLanguage(userPreference.Language);
  loginInfo.save();
  // window.location.reload();
  // history.go(0);

  const currentPath = window.location.hash.replace('#', '');
  history.replace({ pathname: "/empty" });
  setTimeout(() => {
    history.replace({ pathname: currentPath });
  });
  // history.replace('/');
  loginInfo.refresh();

  // window.LabelMapping = window.LabelMappingDict[loginInfo.language];
  // history.replace('/');
}

export const loadUserPreference = function () {
  var userPreference = getCookie("UserPreference");
  if (userPreference != "")
    loginInfo.UserPreference = JSON.parse(userPreference);
}

export const setLocation = function (locationObj) {
  setCookie("UserLocation", JSON.stringify(locationObj), 30);
  loginInfo.LocationCode = locationObj.LocationCode || "";
  loginInfo.LocationDesc = locationObj.LocationDesc || null;
  loginInfo.LocationType = locationObj.LocationType || "";
  console.log("setLocation: ", loginInfo.LocationCode, loginInfo.LocationDesc)
  loginInfo.save();
  // if (loginInfo.UserType == "L")
  //   history.replace('/Kiosk/ProductLineHome');
  // else if (loginInfo.UserType == "S")
  //   history.replace("/Kiosk/Home");
  // else if (loginInfo.UserType == "M")
  //   history.replace("/HomeManagement");
  // else
  //   history.replace('/');
}

export const setUserType = function (UserType) {
  setCookie("UserType", JSON.stringify(UserType), 30);
  loginInfo.UserType = UserType || '';
  // console.log("setUserType: ", UserType)
  if (UserType == 'P')
    setLocation({});
  else
    loginInfo.save();
}

export const updateUserShortcutStatus = function (status, index) {
  loginInfo.UserShortcutList[index].Status = status || {};
  console.log("updateUserShortcutStatus: ", status)
  loginInfo.save();
}

export const logout = function () {

  let url = 'Logout';
  let data = { session: loginInfo.Session };
  loginInfo.clear();

  loginInfo.endUpdateSession();

  ajaxPost(url, data).then(response => {

    console.log(response);

  });
  history.replace("/login");
}

export const downloadFile = function (url) {

  window.location = url;
}

export const timeDiffInSeconds = function (dt2, dt1) {

  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  //diff /= (60 * 60);
  return Math.abs(Math.round(diff));

}

const typeMapping = {
  'Done': 'success',
  'Done.': 'success',
}
window.alert = (msg, callback, type,
  showNextButton, callback2) => {

  if (typeof callback == "string") type = callback;
  if (showNextButton)
    Swal.fire({
      html: LabelMapping[msg] || msg,
      type: (type || typeMapping[msg] || 'info'),
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: LabelMapping['Remain here'] || 'Remain here',
      cancelButtonText: LabelMapping['Next Step'] || 'Next Step',

      // animation: false,
      // customClass: 'animated faster zoomIn'

    }).then((result) => {
      console.log(result);
      if (result.value) {
        if (callback)
          callback();
      } else {

        if (callback2)
          callback2();
      }
    })
  else
    // Swal.fire(
    //   '',
    //   LabelMapping[msg] || msg,
    //   (type || typeMapping[msg] || 'info'),
    // )

    Swal.fire({
      html: LabelMapping[msg] || msg,
      type: (type || typeMapping[msg] || 'info'),
      // animation: false,
      // customClass: 'animated faster zoomIn'

    }).then(() => {
      if (callback)
        callback();
    })
}

window.confirm = (msg, callback, cancelCallback) => {
  Swal.fire({
    text: LabelMapping[msg] || msg,
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: LabelMapping['Confirm'] || 'Confirm',
    cancelButtonText: LabelMapping['Cancel'] || 'Cancel',

    // animation: false,
    // customClass: 'animated faster zoomIn'
  }).then((result) => {
    if (result.value) {
      if (callback)
        callback();
    } else if (cancelCallback) {
      cancelCallback();
    }
  })
}

export const selectAlert = (msg, buttons, type) => {
  var html = LabelMapping[msg] || msg + '<br/><br/>';
  buttons.map((btnObj, index) => {
    html += '<button type="button" id="btn' + index + '" class="swal2-confirm swal2-styled" ' +
      (btnObj.color ? 'style="background-color: ' + btnObj.color + ';">' : '>') + btnObj.text + '</button>';
  });
  Swal.fire({
    // title: LabelMapping[msg] || msg,
    type: (type || typeMapping[msg] || 'info'),
    html: html,
    showConfirmButton: false,
    onBeforeOpen: () => {
      buttons.map((btnObj, index) => {
        document.getElementById('btn' + index).addEventListener('click', () => {
          Swal.closeModal();
          btnObj.callback();
        });
      });
    }

  })
}

export const calculateCalUsage = function (quantityN, quantityD, wastage, roundUp = true) {
  if (!quantityD) return 0;

  var calUsage = 0;

  if (!quantityN) {
    quantityN = 0;
  }
  if (!wastage) {
    wastage = 0;
  }

  calUsage = parseFloat(quantityN) / parseFloat(quantityD) * (1 + parseFloat(wastage) / 100);
  if (roundUp)
    return +(Math.round(calUsage + "e+4") + "e-4");
  else
    return calUsage;
};

export const calculateNetUnitPrice = function (unitPrice, discountPercentage) {
  var netUnitPrice = 0;

  if (!unitPrice) {
    unitPrice = 0;
  }
  if (!discountPercentage) {
    discountPercentage = 0;
  }

  netUnitPrice = parseFloat(unitPrice) * (1 - parseFloat(discountPercentage) / 100);

  return +(Math.round(netUnitPrice + "e+2") + "e-2");
};

export const calculateDiscountPercentage = function (unitPrice, netUnitPrice) {
  var DiscountPercentage = 0;

  if (!unitPrice) {
    unitPrice = 0;
  }
  if (!netUnitPrice) {
    netUnitPrice = 0;
  }

  DiscountPercentage = (1 - (netUnitPrice / unitPrice)) * 100;

  if (!DiscountPercentage && DiscountPercentage !== 0)
    DiscountPercentage = 0;

  return +(Math.round(DiscountPercentage + "e+2") + "e-2");
};

export const GetConversionRateByBaseUnit = function (ProductCode, UnitCode, ConvertUnit, callback) {
  // console.log("=====GetConversionRateByBaseUnit=====")

  // console.log("ProductCode", ProductCode)
  // console.log("UnitCode", UnitCode)
  // console.log("ConvertUnit", ConvertUnit)

  var url = "FB.GetUnitConvertRateByBaseUnit"
  ajaxPost(url, {
    UnitCode: UnitCode,
    ConvertUnit: ConvertUnit,
    ProductCode: ProductCode
  }).then(response => {
    console.log("GetUnitConvertRateByBaseUnit", response)

    if (response.message) {
      alert(response.message);
      return;
    }

    if (callback)
      callback(response)
  });
};

String.prototype.splitCapitalLetter = function () {
  return this.replace(/([A-Z])/g, ' $1').trim()
}

export const isEquivalent = (a, b) => {
  if (a == undefined || b == undefined) return false;
  var objectType = typeof a;
  switch (objectType) {
    case 'object':
      if (Array.isArray(a)) {
        if (a.length != b.length) return false;

        for (var i = 0, aItem, bItem; aItem = a[i]; i++) {
          bItem = b[i];
          if (isEquivalent(aItem, bItem)) continue;
          return false;
        }

      } else {

        // Create arrays of property names
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);

        // If number of properties is different,
        // objects are not equivalent
        if (aProps.length != bProps.length) {
          return false;
        }

        for (var i = 0; i < aProps.length; i++) {
          var propName = aProps[i];

          // If values of same property are not equal,
          // objects are not equivalent
          if (!isEquivalent(a[propName], b[propName])) {
            return false;
          }
        }

      }
      return true;
    default:
      return a == b;
  }

}

export const sendWhatsApp = (values, callback) => {
  var url = 'FB.GetWhatsAppMsg';
  var data = { PONo: values.PONo }

  ajaxPost(url, data).then(response => {
    console.log("GetWhatsAppMsg response: ", response);

    if (response.getStatus == "1") {
      window.open(response.URL);
      if (callback) {
        callback("W", values.PONo);
      }
    }


    else {
      alert('Fail to send');
    }


  });
}

export const getFBReport = (ajaxData, callback) => {
  var url = 'FB.Report';
  ajaxPost(url, ajaxData, true).then(response => {
    if (response)
      callback(response);
  });

}

export const SendPO = (SendType, values, needSaveLog, callback) => {
  var url = 'FB.Report';

  let criteria = [];
  criteria.push(["PONo", values.PONo, values.PONo]);
  var data = { ReportID: 'Fr02po', Format: 1, Criteria: JSON.stringify(criteria) };

  ajaxPost(url, data).then(response => {
    console.log("FB Report response: ", response)
    if (response.status == "success") {
      var reportPath = response.path;

      // Send Mail
      var url = 'FB.SendPO';
      var data = { SendType: SendType, PONo: values.PONo, ReportPath: reportPath }

      ajaxPost(url, data).then(response => {
        console.log("SendPO response: ", response);
        if (!response.errorMessage && response.status == "success") {
          if (needSaveLog)
            SavePOSendLog(SendType.substring(0, 1), values.PONo);
          if (callback)
            callback();
        }
        else {
          alert(response.errorMessage)
          if (callback) {
            callback();
          }
        }
        // alert(response.status);
      });
    } else {
      alert(response.message);
    }
  });
}


export const SavePOSendLog = (SendType, PONo, callback) => {
  console.log("=====save POSendLog=====")
  console.log(SendType)
  console.log(PONo)

  var LogObj = { Action: SendType, PONo: PONo };
  var url = 'FB.SavePOSendLog';
  var data = {
    LogObj: JSON.stringify(LogObj),
  }
  ajaxPost(url, data).then(response => {
    console.log("SavePOSendLog response: ", response);

    if (callback)
      callback();
    return;
  });

}

export const GenSuffixDescription = (obj) => {
  var description = "";
  ["Description1", "Description2", "Description3",
    "UDField1", "UDField2", "UDField3", "UDField4"].forEach(field => {
      if (obj[field] && obj[field] !== "")
        description += obj[field];
    })

  return description
}

export const GetExchangeRate = (date, currency, callback) => {
  var url = 'FB.GetExchangeRate';

  ajaxPost(url, {
    TargetDate: date,
    CurrencyCode: currency
  }).then(response => {
    console.log("GetExchangeRate", response);
    if (!response.errorMessage && callback)
      callback(response.ExchangeRate)
  });
}

//init login info
export const loginInfo = new LoginInfo();

var tmpConnection = {};
if (window.signalr)
  tmpConnection = new HubConnectionBuilder()
    .withUrl(window.signalr)
    .build();

export const connection = tmpConnection;

if (typeof (sessionStorage) !== "undefined") {
  if (sessionStorage["loginInfo"]) {
    Object.assign(loginInfo, JSON.parse(sessionStorage["loginInfo"]));
    loginInfo.updateSession(true);

  }
  // else if (localStorage["loginInfo"]) {
  //   sessionStorage["loginInfo"] = localStorage["loginInfo"];
  //   Object.assign(loginInfo, JSON.parse(localStorage["loginInfo"]));
  //   loginInfo.updateSession(true);
  // } 
  else {
    loginInfo.clear();
  }
  loadUserPreference();
  checkLanguage();

  if (sessionStorage["SystemTimestamp"]) {

    var timestampDiff = new OriginalDate().getTime() - parseFloat(sessionStorage["OriginTimestamp"]);
    let timestamp = parseFloat(sessionStorage["SystemTimestamp"]) + timestampDiff;

    timemachine.config({

      timestamp: timestamp,
      tick: true,
    });
  }

} else {
  // Sorry! No Web Storage support..
  console.log("Sorry! No Web Storage support..");
}

export const logMessageToChatRoom = (message) => {
  // var isDev = true;
  // var messageObj = {

  //   Message: message,
  //   ChatRoomID: "CR000001",
  //   From: "VICTOR",
  //   To: "ACC1",
  // }

  // //For offline log

  // let isOffline = checkIsOffline();
  // if (isOffline || isDev) {
  //   if (!loginInfo.Messages)
  //     loginInfo.Messages = [];
  //   loginInfo.Messages.push(messageObj);
  // }
  // else {
  //   //For send log to save data
  //   // var url = "FB.SaveChatRoomMessage";

  //   // ajaxPost(url, {
  //   //   Obj: JSON.stringify(messageObj)
  //   // }).then(response => {
  //   // });
  // }


}

export const genOfflineUrl = url => {
  return `${window.host}/${url}`
}

export const getOfflineKey = () => {
  return `${loginInfo.Ledger}-${loginInfo.LocationCode}`;
}

export const RemarkDocType = {
  'Quotation': 0,
  'SalesOrder': 1,
  'CustomerInvoice': 2,
  'SalesReturn': 3,
  'PurchaseReturn': 4,
  'DeliveryNote': 5,
}

export const _barCodeLength = 8;

var pressed = false;
var chars = [];
var stopScan = false;
export const barCodeScan = function (keyEvent, callback) {
  if (keyEvent.keyCode == 13 || keyEvent.keyCode == 9)
    stopScan = true;

  if (!stopScan && keyEvent.keyCode != 16 && keyEvent.keyCode != 13)
    chars.push(keyEvent.key);

  if (pressed == false) {
    pressed = true;

    var promise = setTimeout(function () {
      if (chars.length >= _barCodeLength) {
        var barcode = chars.join("");
        console.log('Barcode result: ', barcode);

        if (callback) callback(barcode);
      }
      // Stop the pending timeout
      clearTimeout(promise);
      chars.length = 0;
      pressed = false;
      stopScan = false;

    }, 500);
  }
  // set press to true so we do not reenter the timeout function above
  pressed = true;
}

export const barCodeScanBak = function (key, callback) {
  chars.push(key);

  if (pressed == false) {
    pressed = true;

    var promise = setTimeout(function () {
      if (chars.length > 10) {
        var barcode = chars.join("");
        console.log('Barcode result: ', barcode);

        if (callback) callback(barcode);
      }
      // Stop the pending timeout
      clearTimeout(promise);
      chars.length = 0;
      pressed = false;

    }, 500);
  }
  // set press to true so we do not reenter the timeout function above
  pressed = true;
}
console.log("loginInfo", loginInfo);



// WEBPACK FOOTER //
// ./src/global.js